import React from "react";

export const CTABanner = () => (
  <section className="cta-banner" data-testid="cta-banner">
    <div className="container-main">
      <h2>Programează-te Astăzi!</h2>
      <p>Sună-ne și unul dintre specialiștii noștri îți va răspunde la toate întrebările.</p>
      <a href="tel:+40256123456" className="cta-phone-btn" data-testid="cta-phone-button">
        <span>📞</span> 0256 123 456
      </a>
    </div>
  </section>
);
